import React, {Component} from 'react';
import {gpn} from "../GPN"
import jMoment from "jalali-moment";
import Back from "../sections/Back";
import DateField from "../sections/MUI/DateField";
import Field from "../sections/MUI/Field";
import Button from "../sections/MUI/Button";

class AzarPM extends Component {

    state = {
        list: [],

        fromDate: jMoment().subtract(1, "jDay").format("jYYYY/jMM/jDD"),
        toDate: jMoment().format("jYYYY/jMM/jDD"),
        fromTime: "18:00",

        search: ""
    };

    render() {
        let {
            list,
            fromDate, toDate, fromTime,
            search
        } = this.state;

        return (
            <>
                <Back {...this.props}/>
                <br/>
                <div className="azar-pm">
                    <div className="row justify-content-center">
                        <div className="col-md-3">
                            <DateField value={fromDate} label="از تاریخ"
                                       onChange={(unix, formatted) => this.setState({fromDate: formatted})}/>
                        </div>
                        <div className="col-md-3">
                            <Field name="fromTime"
                                   value={fromTime}
                                   label="از ساعت"
                                   maxLength={5}
                                   style={{direction: "ltr"}}
                                   onChange={(n, v) => this.setState({[n]: v})}/>
                        </div>
                        <div className="col-md-3">
                            <DateField value={toDate} label="تا تاریخ"
                                       onChange={(unix, formatted) => this.setState({toDate: formatted})}/>
                        </div>
                        <div className="col-md-3">
                            <Button icon="search">اعمال</Button>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}


export default gpn(AzarPM);